
module cr.entity
{
    entityModule.config(["$stateProvider",
        ($stateProvider: any) => {

            $stateProvider
                .state("entity", {
                    url: "/entity",
                    ncyBreadcrumb: {
                        label: "{{'ENTITY'|t}}"
                    },
                    abstract:true,
                    templateUrl: 'modules/entity/views/entitytemplate.html',

                    resolve: {
                      /*  userPermissionService: function (permissionManagementService: cr.permission.IPermissionManagementService) {
                            return permissionManagementService.GetUserPermissions();
                        }*/
                    },

                    data: {
                       permissions: 'role.superadmin'
                    }
                }).state("entity.index",{
                    templateUrl: 'modules/entity/views/index.html',
                    ncyBreadcrumb: {
                        skip:true
                    },
                    controller: 'entityHomeController',
                    url:"",
                    resolve: {
                        moduleList:  function(entityService:IEntityService): angular.IPromise<Array<EntityModuleView>>{
                            return entityService.getModules();
                        }
                    }
                }).state("entity.module", {
                        url: "/{moduleName}",
                        ncyBreadcrumb: {
                            label: "{{ctrl.entityModule.Name|t}}"
                        },
                        views:{
                            '':
                            {
                                templateUrl: 'modules/entity/views/treetemplate.html',
                                controller: 'entityModuleHomeController',
                                controllerAs:'ctrl'
                            },
                            'subtitle':
                            {
                                template: '{{ctrl.entityModule.Name|t}}',
                                //controller: 'entityModuleHomeController',
                                //controllerAs:'ctrl'
                            }
                        },
                        resolve : {
                            entityModule: function(entityService:IEntityService, $stateParams:any)
                            {
                                return entityService.getModuleDetail($stateParams.moduleName);
                            },

                            treeManager:function($state,$q){
                                return new TreeManager($state,$q);
                            }
                        }
                    }
                )

        }]);
}
